import {ClientExecQuery, ClientExecMsg} from '../autogenerated/ZoomBridge';


export default class NativeActionUtil {
  static runExecQuery(paths, command, target = undefined, fuid = undefined) {
    const query = new ClientExecQuery();
    const queryMsg: ClientExecMsg = new ClientExecMsg();
    queryMsg.setCmdName(command);
    queryMsg.setPath(paths);
    if (target)
      queryMsg.setTarget(target);

    if (fuid)
      queryMsg.setFuid(fuid);

    query.message = queryMsg;
    query.run().then(
      (resp) => {
        console.log("Received response " + resp);
      },
      (error) => {
        console.log("Error " + error);
      }
    );

  }

}